export type Voice = {
    // 入力音
    inputVolume: number;
    // 出力音
    outputVolume: number;
    isMute: boolean;
    isTalking: boolean;
};

export type Mic = {
    label: string;
    deviceId: string;
};

// chromeでは、osで選択されているmicは、2重に取得されることがある。
// 2重に取得されたmicは、
// 「正しいlabelと正しいdeviceIdで登録されたmic」に加えて、
// 「先頭に`Default`という文字列が追加されたlabel、`default`というdeviceIdをもつmic」
// の2つが取得される。
// この関数では、その2つのうち「正しいlabelと正しいdeviceIdで登録されたmic」を取得する
export const GetDefaultMic = (mics: Mic[]): Mic | undefined => {
    const defaultMic = mics.find((mic) => mic.deviceId === 'default');
    if (defaultMic === undefined) {
        return;
    }
    return mics.find((mic) => mic.deviceId !== 'default' && defaultMic.label.includes(mic.label));
};
